const NO_SPECIAL_CHARS_REGEX = /^([a-zA-Z0-9-?:().,+'/\s]*)$/;
const COR_REGEX = /^[0-9]{20}$/;
const BIK_REGEX = /^[0-9]{9}$/;
const INN_REGEX = /^([0-9]{10}|[0-9]{12})$/;
const KPP_REGEX = /(^$)|(^\d{9}$)/;
const BIC_REGEX = /^(?!\s)(?![\s\S]*\s$)[A-Z]{4}[A-Z]{2}[A-Z0-9]{2,5}[[0-9]{0}|[0-9]{3}]$/;

export { NO_SPECIAL_CHARS_REGEX, COR_REGEX, BIK_REGEX, INN_REGEX, KPP_REGEX, BIC_REGEX };
